module.exports = __webpack_public_path__ + "static/media/msl_tactical_plus_4-3.bfbdc3da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl_tactical_plus_4-3.jpg
// module id = 79
// module chunks = 0